import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, finalize, Observable, tap } from 'rxjs';
import { MockPath, RequestOptions } from '..//models/http-helper';
import { AppState } from '../models/state';
import { StateService } from './state.service';
import { UiService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {


  constructor(
    private stateService: StateService,
    private ui: UiService,
    private http: HttpClient,
  ) {
  }

  get(url: string, options?: RequestOptions) {
    const state = this.stateService.getStateValue();

    if (state.develop) {
      return this.getMockResponse(options?.mockPath);
    }
    this.ui.showSpinner();
    return this.http.get(url, options).pipe(
      finalize(
        () => { this.ui.stopSpinner(); }
      )
    );
  }

  getMockResponse(path: MockPath): Observable<any> {
    return this.http.get(`../../../assets/mocks/${path}.json`);
  }
}
